import React from 'react';
import styled from 'styled-components';

const CardWrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  cursor: pointer;
  height: 300px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
    filter: grayscale(100%);
  }
  
  &:hover img {
    transform: scale(1.05);
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
  color: white;
  padding: 25px 15px;
  text-align: center;
  
  h3 {
    font-size: 24px;
    font-weight: 500;
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    text-transform: none;
  }
`;

const IndustryCard = ({ title, image }) => {
  // Format the title to capitalize only the first letter of each word
  const formatTitle = (text) => {
    return text.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  };

  return (
    <CardWrapper>
      <img src={image} alt={title} />
      <CardOverlay>
        <h3>{formatTitle(title)}</h3>
      </CardOverlay>
    </CardWrapper>
  );
};

export default IndustryCard; 